/**
 * Platform router: native app → mobile/documents.js, web/desktop → storage.js unchanged.
 */
import { isNativeApp } from '../core/platform';
import {
  viewDocument as viewDocumentWeb,
  downloadDocument as downloadDocumentWeb,
  normalizeDocRef,
  openDocumentPreviewTab,
} from '../storage';
import { viewDocumentMobile, downloadDocumentMobile } from './documents';

export { normalizeDocRef, openDocumentPreviewTab };

export async function viewDocument(docObj, fallbackName, ctx, preOpenedWindow) {
  if (isNativeApp()) return viewDocumentMobile(docObj, fallbackName, ctx);
  return viewDocumentWeb(docObj, fallbackName, ctx, preOpenedWindow);
}

export async function downloadDocument(docObj, fallbackName, ctx) {
  if (isNativeApp()) return downloadDocumentMobile(docObj, fallbackName, ctx);
  return downloadDocumentWeb(docObj, fallbackName, ctx);
}
